import { render, staticRenderFns } from "./IndexContent.vue?vue&type=template&id=85cd79e6&scoped=true&"
import script from "./IndexContent.vue?vue&type=script&lang=js&"
export * from "./IndexContent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=85cd79e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cd79e6",
  null
  
)

export default component.exports